import { differenceInYears } from 'date-fns';
import * as z from 'zod';

import type { CreateSchemaTypes } from '../createZodSchema';

export function datePickerValidator(field: CreateSchemaTypes) {
  const validator = z
    .date({ error: 'Datum is verplicht' })
    .superRefine((date, ctx) => {
      if (field.minEighteen) {
        const today = new Date();
        const age = differenceInYears(today, date);

        if (age < 18) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Moet minstens 18 jaar oud zijn',
            fatal: true,
          });
        }
      }
    });

  if (field.required) {
    return validator;
  }

  return z.preprocess((value) => (value === '' ? undefined : value), validator.optional());
}
